import React from "react";
import { useTranslation } from "react-i18next";
import { CARD_ACTION_SCORE, CARD_WILD_SCORE, GameConstant } from "@uno/protocol";

const RULE_STEPS = [
    { titleKey: "room.rules_cards_title", bodyKey: "room.rules_cards_body" },
    { titleKey: "room.rules_ranking_title", bodyKey: "room.rules_ranking_body" },
    { titleKey: "room.rules_abandon_title", bodyKey: "room.rules_abandon_body" },
    { titleKey: "room.rules_min_loss_title", bodyKey: "room.rules_min_loss_body" },
    { titleKey: "room.rules_cap_loss_title", bodyKey: "room.rules_cap_loss_body" },
    { titleKey: "room.rules_payout_title", bodyKey: "room.rules_payout_body" },
    { titleKey: "room.rules_cap_gain_title", bodyKey: "room.rules_cap_gain_body" },
    { titleKey: "room.rules_tiebreaker_title", bodyKey: "room.rules_tiebreaker_body" },
];

const RULE_INTERPOLATIONS: Record<string, Record<string, number>> = {
    "room.rules_cards_body": {
        actionValue: CARD_ACTION_SCORE,
        wildValue: CARD_WILD_SCORE,
    },
    "room.rules_abandon_body": {
        maxLoss: GameConstant.maxLoss,
    },
    "room.rules_cap_loss_body": {
        maxLoss: GameConstant.maxLoss,
    },
    "room.rules_min_loss_body": {
        min1: GameConstant.minLossPerRank,
        min2: GameConstant.minLossPerRank * 2,
        min3: GameConstant.minLossPerRank * 3,
    },
    "room.rules_cap_gain_body": {
        maxGain: GameConstant.maxGain,
    },
};

const RulesView: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="max-h-[65vh] overflow-y-auto rounded-2xl bg-white/10 border border-white/10 p-5 md:p-6 space-y-4 panel-scrollbar">
            {RULE_STEPS.map((step, index) => (
                <div key={step.titleKey} className="flex gap-3">
                    <span className="shrink-0 w-7 h-7 rounded-full bg-white/15 text-white font-changa-one text-sm flex items-center justify-center">
                        {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                        <p className="text-white font-changa-one text-sm mb-1">{t(step.titleKey)}</p>
                        <p className="text-white/60 text-xs leading-relaxed">
                            {t(step.bodyKey, RULE_INTERPOLATIONS[step.bodyKey] ?? {})}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RulesView;
